import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {Routes, RouterModule} from '@angular/router';

import {IonicModule} from '@ionic/angular';

import {AdminModelPage} from './admin-model.page';
import {GlobalModule} from "../../../global-module/global-module.module";

const routes: Routes = [
    {
        path: '',
        component: AdminModelPage
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        GlobalModule,
        IonicModule,
        RouterModule.forChild(routes)
    ],
    declarations: [AdminModelPage]
})
export class AdminModelPageModule {
}
